import ReactDOM from 'react-dom/client';
import { Wrapper } from "@googlemaps/react-wrapper";
import { Route } from "wouter";
import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import App from './App';
import ResetPwd from './components/ResetPwd.js';
import RequestResetPwd from './components/RequestResetPwd.js';
import CreatePdfStories from './components/CreatePdfStories.js';
import { messages } from "./locales/it/messages";
import { decrypt } from "./components/Utility.js"
import './index.css';
let host = "maps.siddialtipiano.it";
if ((host === window.location.host) && (window.location.protocol !== "https:")){
window.location.protocol = "https";
}
// Load message translation in italian
i18n.load("it", messages);
i18n.activate("it");
const googleApiKey = process.env.REACT_APP_GOOGLE_API_KEY;
// Use the wrapper to add Google Maps features, an i18n provider for translations, and routing. 
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Wrapper apiKey={googleApiKey} libraries={["marker", "places"]} >
        <I18nProvider i18n={i18n}>
            <Route path="/"> <App /></Route>
            {/* Centre the map at a specific location */ } 
            <Route path="/stories/:position">
                {(params) => <App initPosition={params.position} />}
            </Route>
            <Route path="/story/:data">
                {(params) => {
                    let dataDecrypted = decrypt(params.data);
                    return <App idInit={dataDecrypted.id} initPosition={{ lat: dataDecrypted.lat, lng: dataDecrypted.lng }} />

                }}
            </Route>
            <Route path="/requestresetpwd">
                <RequestResetPwd />
            </Route>
            <Route path="/createpdfstories">
                <CreatePdfStories />
            </Route>
            <Route path="/resetpwd/:id/:token" >
                {(params) =>
                    <ResetPwd id={params.id} token={params.token} />
                }
            </Route>
        </I18nProvider>
    </Wrapper>
);

